import { render, staticRenderFns } from "./InfoTable.vue?vue&type=template&id=22027608&scoped=true&lang=html&"
import script from "./InfoTable.vue?vue&type=script&lang=js&"
export * from "./InfoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22027608",
  null
  
)

export default component.exports